import { AddToCartButton, Asset, MatchingProduct, PriceContainer, SolutionComponent } from '../Types/MatchingProducts';
import { setAddToCartButton, setPricePDP, refreshPlacements } from '../../FitAssistantShared/Functions';
import { createRoot } from 'react-dom/client';
import React from 'react';
import FittingInstructionMovie from '../../FitAssistantShared/FittingInstructionMovie';
import { FitAssistantProductsResponse } from '../Types/FitAssistantProductsResponse';
import { initMobileSlider } from '../../../ProductDetail';

export const setAddToCartBtnForDBG = (pli: HTMLDivElement, matchingProduct: MatchingProduct) => {
  if (!pli || !matchingProduct || !window._THULEDATA?._buyersGuide) return;
  let productIdsElement: HTMLInputElement = pli.querySelector(
    '.product-add-to-cart .product-ids-for-solution'
  ) as HTMLInputElement;
  if (productIdsElement) {
    productIdsElement.value = matchingProduct.ProductIds.join(',');
  }
};

export const UpdateFitAssistantPriceAndATCForPDP = (
  solutionPriceContainer: PriceContainer,
  addToCartButton: AddToCartButton
) => {
  setAddToCartButton(addToCartButton, true);
  setPricePDP(solutionPriceContainer);
  refreshPlacements(solutionPriceContainer);
};

export const UpdateFitAssistantPriceAndATCForPDPExtranet = (
  solutionComponents: SolutionComponent[],
  priceContainer: PriceContainer
) => {
  if (!solutionComponents) return;

  var productBuyArea: HTMLDivElement = document.querySelector('#productBuyArea') as HTMLDivElement;
  var priceElement: HTMLDivElement = productBuyArea.querySelector('.price') as HTMLDivElement;
  var addToCartElement: HTMLDivElement = productBuyArea.querySelector('.add-to-your-cart') as HTMLDivElement;
  var spinner: HTMLDivElement = productBuyArea.querySelector('.loading-spinner') as HTMLDivElement;

  spinner?.classList.remove('d-none');
  priceElement?.classList.add('d-none');
  addToCartElement?.classList.add('d-none');

  import('./SolutionAddToCart')
    .then((module) => module.getSolutionPriceFromM3(solutionComponents, priceContainer))
    .then(() => {
      spinner.classList.add('d-none');
      priceElement.classList.remove('d-none');
      addToCartElement.classList.remove('d-none');
    });
};

export const setImageBasedOnRoofRack = (response: FitAssistantProductsResponse) => {
  if (!response?.MatchingProducts || response.MatchingProducts.length === 0) return;

  const footGeneration = response.MatchingProducts[0].SolutionFootGeneration;
  const footType = response.MatchingProducts[0].SolutionFootType;

  let containerDiv = document.querySelector('.pdp__mainImages[data-isroofrack="True"]') as HTMLElement;
  if (!containerDiv || !footGeneration || !footType) return;
  let imageWrappers = containerDiv.querySelectorAll('.pdp__mainImageWrapper') as NodeListOf<HTMLElement>;
  imageWrappers.forEach((imageWrapper) => {
    if (imageWrapper.dataset.generation === footGeneration && imageWrapper.dataset.foottype === footType) {
      imageWrapper.classList.remove('d-none');
      imageWrapper.classList.add('splide__slide');
    } else {
      imageWrapper.classList.add('d-none');
      imageWrapper.classList.remove('splide__slide');
    }
  });
  initMobileSlider();
};

export const handleDocuments = (solutionComponents: SolutionComponent[]) => {
  const documentContainerElement = document.querySelector('#documentsContainer') as HTMLElement;
  const instructionMovieContainer = document.getElementById('image-navigation') as HTMLElement;
  if (!documentContainerElement || !solutionComponents) return;
  documentContainerElement.innerHTML = '';
  if (instructionMovieContainer) {
    instructionMovieContainer.querySelectorAll('.fittingInstructionMovie').forEach((movie) => {
      movie.remove();
    });
  }
  let assetIds: string[] = [];
  solutionComponents.forEach((c) => {
    if (c.Informationdoc?.length > 0) {
      addInstructions(c.Informationdoc, c.InformationDocumentsLinkText, assetIds);
    }

    if (c.FittingInstruction?.length > 0) {
      addInstructions(c.FittingInstruction, c.FittingInstructionLinkText, assetIds);
    }

    if (c.CompatibilityDocuments?.length > 0) {
      addInstructions(c.CompatibilityDocuments, c.CompatibilityDocumentsLinkText, assetIds);
    }

    if (c.FittingInstructionMovies?.length > 0) {
      addFittingInstructionMovies(c, instructionMovieContainer);
    }
  });
};

const addInstructions = (instructionsList: Asset[], linkText: string, assetIds: string[]) => {
  const documentContainerElement = document.querySelector('#documentsContainer');
  if (!documentContainerElement) return;
  instructionsList.forEach((d) => {
    if (assetIds.indexOf(d.AssetId) === -1) {
      assetIds.push(d.AssetId);
      const icon = d.IconCssClass ? `<i class="${d.IconCssClass}"></i>` : '';
      documentContainerElement.innerHTML += `<li class="downloadable-asset">${icon} <a target="_blank" class="tag-manager-user-manual paragraph--s text-decoration-underline" href="${d.AssetURL}" data-assettype="${d.FileEnding}">${linkText}</a></li>`;
    }
  });
};

const addFittingInstructionMovies = (component: SolutionComponent, instructionMovieContainer: HTMLElement) => {
  if (component?.FittingInstructionMovies && instructionMovieContainer) {
    component.FittingInstructionMovies.forEach((movie: Asset, index: number) => {
      const html = `<div class="h-100 w-100" id="fittingInstructionMovie-${index}"></div>`;
      instructionMovieContainer.innerHTML += html;

      const placeholder = document.getElementById(`fittingInstructionMovie-${index}`);
      if (placeholder) {
        const root = createRoot(placeholder);
        root.render(<FittingInstructionMovie component={movie} index={index} />);
      }
    });
  }
};
